export enum TemplateType {
  NewTicket = 'NewTicket',
  Reinitialise = 'Reinitialise',
  FormRequest = 'FormRequest',
  FormComplete = 'FormComplete',
  PaymentRequest = 'PaymentRequest',
  PaymentRequestMessage = "PaymentRequestMessage",
  PaymentPaid = 'PaymentPaid',
  PaymentRefunded = 'PaymentRefunded',
  PreAuthorisationSuccess = 'PreAuthorisationSuccess',
  Custom = 'Custom',
  Campaign = 'Campaign',
  CampaignWithPayment = 'CampaignWithPayment',
  Notification = 'Notification',
  Welcome = 'Welcome',
  Standard = 'Standard',
  ProductRequestUpdate = 'ProductRequestUpdate',
  ReminderAppointment = 'ReminderAppointment',
  ReminderPayment = 'ReminderPayment',
  ReminderVaccination = 'ReminderVaccination',
  ReminderParasiticide = 'ReminderParasiticide',
  ReminderPreOperation = 'ReminderPreOperation',
  ReminderPostOperation = 'ReminderPostOperation',
  ReminderHealthCarePlan = 'ReminderHealthCarePlan',
  ReminderHealthCarePlanFollowUp = 'ReminderHealthCarePlanFollowUp',
  ReminderSnoozeResponse = "ReminderSnoozeResponse",
  ManagePreferencesResponse = "ManagePreferencesResponse",
  OptInResponse = "OptInResponse",
  OptOutResponse = "OptOutResponse",
  HelpResponse = "HelpResponse",
  ComplianceWelcome = "ComplianceWelcome",
  ExternalReminder = "ExternalReminder",
  ProductFollowup = "ProductFollowup",
  ReminderRebook = "ReminderRebook",
  
}
